var _rect, _rect2, _rect3, _ellipse, _ellipse2, _path, _circle, _path2, _path3, _path4, _rect4, _rect5, _circle2, _path5, _path6, _ellipse3, _ellipse4, _ellipse5, _path7, _polygon, _polygon2, _path8, _path9, _path0, _circle3, _path1, _path10, _path11, _path12, _path13, _ellipse6, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetflixClone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a661a32f-c611-43a1-9e61-6cb14e85c52e",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1004.25325,
    height: 711.94329,
    viewBox: "0 0 1004.25325 711.94329",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "netflix") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 713.67413,
    y: 564.64779,
    width: 267.14533,
    height: 1.8747,
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 784.91288,
    y: 601.20452,
    width: 219.34037,
    height: 1.8747,
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 838.33386,
    y: 231.23309,
    width: 1.8747,
    height: 335.24432,
    fill: "#3f3d56"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 839.63279,
    cy: 454.32287,
    rx: 36.55673,
    ry: 83.42433,
    fill: "#3f3d56"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 839.63279,
    cy: 264.04041,
    rx: 36.55673,
    ry: 83.42433,
    fill: "#3f3d56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M938.40415,289.91119l-1.796-.53825c.11351-.379,11.13471-38.14721-6.962-62.46069-10.22116-13.73166-27.76035-20.69452-52.13059-20.69452V204.343c24.9991,0,43.04588,7.21917,53.6396,21.457C949.81211,250.8756,938.5204,289.524,938.40415,289.91119Z",
    transform: "translate(-97.87337 -94.02835)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 779.64226,
    cy: 111.25203,
    r: 23.4338,
    fill: "#d04414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M854.2104,634.409H829.83925V610.03782H854.2104ZM831.714,632.53427h20.62174V611.91253H831.714Z",
    transform: "translate(-97.87337 -94.02835)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M268.77321,587.55083c.03061,63.03091-37.43,85.05421-83.6489,85.07666q-1.61038.00078-3.20524-.03441-3.21309-.06775-6.35929-.2897c-41.71554-2.93327-74.13856-26.05266-74.167-84.67126-.02946-60.663,77.46487-137.25616,83.2767-142.9195.00508,0,.00508,0,.01022-.00514.22079-.21584.33379-.32374.33379-.32374S268.7426,524.525,268.77321,587.55083Z",
    transform: "translate(-97.87337 -94.02835)",
    fill: "#d04414"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M182.07361,662.9876l30.58807-42.782-30.66285,47.47688-.07976,4.9106q-3.21309-.06775-6.35929-.2897l3.26709-63.05821-.02589-.48794.05639-.09251.31049-5.95857L148.38179,555.141l30.87633,43.10144.07767,1.26357,2.46809-47.643L155.4448,502.7085l26.67862,40.78177,2.546-98.77765.01006-.32872.00016.32358-.39356,77.8964,26.1969-30.89383-26.3067,37.60225-.67271,42.65959,24.46614-40.95038-24.56066,47.2222-.37372,23.72089,35.50712-57.00243-35.6418,65.27752Z",
    transform: "translate(-97.87337 -94.02835)",
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.60656,
    y: 577.64779,
    width: 158.41249,
    height: 1.8747,
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 193.57643,
    y: 15.93498,
    width: 431.18193,
    height: 1.8747,
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 322.37855,
    cy: 17.80969,
    r: 17.80969,
    fill: "#d04414"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.21975,457.25631A11.24823,11.24823,0,1,1,123.468,446.00809,11.26082,11.26082,0,0,1,112.21975,457.25631Zm0-20.62174a9.37352,9.37352,0,1,0,9.37352,9.37352A9.38426,9.38426,0,0,0,112.21975,436.63457Z",
    transform: "translate(-97.87337 -94.02835)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M272.02264,415.02253H247.65149V390.65137h24.37115Zm-22.49645-1.87471h20.62174V392.52608H249.52619Z",
    transform: "translate(-97.87337 -94.02835)",
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 417.5,
    cy: 645.29893,
    rx: 417.5,
    ry: 9.69734,
    fill: "#3f3d56"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 417.5,
    cy: 677.37474,
    rx: 289.03846,
    ry: 6.71354,
    fill: "#3f3d56"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 417.63207,
    cy: 706.46676,
    rx: 235.78148,
    ry: 5.47653,
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M720.887,562.42307l-1.37248,28.82211,65.8791,21.9597s-3.4312-36.37075-1.37248-39.802Z",
    transform: "translate(-97.87337 -94.02835)",
    fill: "#ffb8b8"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "515.96 596.722 509.784 620.74 538.606 620.74 538.606 596.722 515.96 596.722",
    fill: "#ffb8b8"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "665.561 603.107 678.599 607.702 685.461 590.471 673.795 581.281 665.561 603.107",
    fill: "#a0616a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M786.53848,667.22724s19.44232-2.55431,19.44232,13.91546,2.745,56.958-24.70467,52.15429c0,0-12.35233,1.37248-7.54864-13.03857,0,0,4.89-5.86241,3.13122-9.45049s-12.05235-6.333-10.67987-8.39177,16.46978-18.52849,16.46978-18.52849Z",
    transform: "translate(-97.87337 -94.02835)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M786.76606,609.77368,719.51448,586.4415,715.397,602.91127s-100.87737-58.33045-107.05354-18.5285c0,0-5.48992,32.25331,2.745,74.80023l.68624,34.312s17.156,4.11744,25.3909.68624l.68624-37.057s6.86241-24.01842,3.4312-42.54692c0,0,51.468,40.4882,74.80023,45.29188,0,0-81.66263,63.13414-72.05526,83.03512s21.27346,23.33218,36.37075,19.901c10.404-2.36454,56.98215-39.92561,84.9364-63.05047a79.26085,79.26085,0,0,0,28.93353-65.1925C793.76852,625.45918,791.66778,616.63608,786.76606,609.77368Z",
    transform: "translate(-97.87337 -94.02835)",
    fill: "#2f2e41"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M612.46094,705.84737s-.68624-8.23489-4.80369-4.80369-18.52849,16.46978-18.52849,16.46978-52.15429,5.72481-20.58722,18.76338a78.2751,78.2751,0,0,0,42.54692-5.48992s35.07469,9.00486,34.35024.26754-8.95934-23.32939-8.95934-23.32939-9.60737,7.04343-20.58722-2.56394Z",
    transform: "translate(-97.87337 -94.02835)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 650.46321,
    cy: 364.08614,
    r: 25.3909,
    fill: "#ffb8b8"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M768.9238,459.487s4.11745,20.58722,11.66609,25.3909l-41.86067,49.40933-15.78354-15.0973,11.66609-20.58722s13.03857-7.54864,8.92113-17.84225Z",
    transform: "translate(-97.87337 -94.02835)",
    fill: "#ffb8b8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M784.0211,486.9366s30.19459,6.17617,33.62579,26.07715-3.4312,56.27173-3.4312,56.27173L799.80463,676.339s-.68624,45.29188-18.5285,37.74323,4.80369-41.86067,4.80369-41.86067L792.256,604.97s2.745-56.958-2.745-63.82038l-21.9597-6.8624S772.355,488.99533,784.0211,486.9366Z",
    transform: "translate(-97.87337 -94.02835)",
    fill: "#ffb8b8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M734.61177,498.60269s-20.58722-.68624-33.62579,15.78354-44.60564,28.82211-44.60564,28.82211l-78.91767,30.88082s-14.41106-25.3909-23.33219-16.46977,16.46978,31.56707,28.13587,28.82211,82.34888-24.01843,82.34888-24.01843l56.27173-25.3909Z",
    transform: "translate(-97.87337 -94.02835)",
    fill: "#ffb8b8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M779.526,483.24269s-26.38575,35.261-38.05184,34.57474-3.80884-21.53617-3.80884-21.53617L729.43045,498.34s-11.28845,21.53617-12.66094,22.90866c0,0-16.46977,26.76338,2.05873,32.93955l.68624,14.41105s45.97812-2.05872,65.8791,8.23489l4.11744-35.68452s-26.07714-13.03857-11.66609-38.42947c0,0,5.11229-13.30129,10.60221-14.67377Z",
    transform: "translate(-97.87337 -94.02835)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M786.42294,671.87846,681.42812,748.73741S787.10918,686.28951,786.42294,671.87846Z",
    transform: "translate(-97.87337 -94.02835)",
    opacity: 0.1
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 676.88348,
    cy: 362.02742,
    rx: 1.98247,
    ry: 4.46056,
    fill: "#ffb8b8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M720.34188,444.63s-7.11653-48.06537,43.70451-33.23456c0,0,35.95295-7.3129,48.65151,37.59055l12.88906,47.078-5.89984-3.06592-2.60784,6.00244-9.4156,2.57782-4.20315-7.95848-1.77128,9.79659L724.34188,512.63s34.31466-21.19294,34.15871-57.992l-6.47715,7.11335Z",
    transform: "translate(-97.87337 -94.02835)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "bf2f48d4-d76c-43f7-acff-29e29e6968d0",
    "data-name": "path4155",
    d: "M546.22228,247.18032l-.19564,109.55741-.19564,109.5574-8.99936-25.433V440.797L525.15856,684.6926c11.47744,32.34552,17.60744,49.6269,17.67265,49.6921s6.58649.45649,14.47723.84775c23.86786,1.17383,53.47445,3.71714,75.97285,6.52128,5.217.65213,9.65148.97819,9.97755.71734s.39127-111.77463.32606-247.87363l-.19564-247.41714h-97.167Z",
    transform: "translate(-97.87337 -94.02835)",
    fill: "#b1060f"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "bfab83f1-a1e5-4c79-84d8-61287c2d74b0",
    "data-name": "path4157",
    d: "M370.47394,246.85426v247.678c0,136.22942.13043,247.80842.32606,248.00405s8.60809-.65213,18.78126-1.76075,24.19394-2.5433,31.1717-3.13021c10.69488-.913,42.77955-2.93457,46.43147-2.99979,1.10861,0,1.17383-5.54308,1.30425-104.92729l.19564-104.9273,7.76031,21.91148c1.17384,3.39106,1.56511,4.43447,2.73894,7.76032l11.67307-243.83044c-2.47808-6.97777-1.17383-3.32585-3.978-11.28179-9.52106-26.93286-17.60744-49.69212-17.9335-50.73551l-.65213-1.826H370.47392Z",
    transform: "translate(-97.87337 -94.02835)",
    fill: "#b1060f"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "ed196cf9-a066-4498-9a77-a0c0f8894188",
    "data-name": "path5721",
    d: "M370.47394,246.85426,468.61911,524.9866v-.13042l7.76032,21.91148c43.10562,122.013,66.25615,187.48662,66.38657,187.617.06521.06521,6.58649.45649,14.47723.84775,23.86786,1.17383,53.47445,3.71714,75.97284,6.52128,5.15181.65213,9.65149.97819,9.91234.71734L545.831,466.22991v.06521l-8.99936-25.433c-8.80372-24.846-14.67287-41.4753-50.08339-141.51164-9.52107-26.93286-17.60744-49.69212-17.93351-50.73551l-.65212-1.826H419.31828l-48.84434.06522Z",
    transform: "translate(-97.87337 -94.02835)",
    fill: "#e50914"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetflixClone);
export default __webpack_public_path__ + "static/media/netflix-clone.bd6388179c0271749d4b1c181f2fadb1.svg";
export { ForwardRef as ReactComponent };